<template>
    <div>
      <p>SamWheating@gmail.com</p>
      <p><a href="https://www.linkedin.com/in/sam-wheating-a2a8a3111/">Linkedin.</a></p>
      <p><a href="https://www.github.com/SamWheating">Github.</a></p>
    </div>
</template>

<script>
export default {
  name: 'Contact',
  props: {
    msg: String
  }
}
</script> 